import styled from 'styled-components'

export const SchoolViewContainerStyles = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
